module.exports = __webpack_public_path__ + "static/sune-symbol-DND3_FnP-bd9b2050a8de663a86a27736740fd195.webp";